import React from "react";

//Custom Imports
import TipsBanner from "../Components/TipsBanner";
import ContestCard from "../Components/ContestCard";
import YourTaskCard from "../Components/YourTaskCard";
import ContestRules from "../Components/ContestRules";
import ContestUpdate from "../Components/ContestUpdate";
import MyPerformance from "../Components/MyPerformance";
import JourneyProgress from "../Components/JourneyProgress";
import OrdersPlacedCard from "../Components/OrdersPlacedCard";
import EligibilityBanner from "../Components/EligibilityBanner";

const RenderContestEntity = (props = {}) => {
  const {
    type,
    isPastContest,
    contest_start_date = null,
    contest_ended = false,
    can_only_view = false,
  } = props;

  let needProps = true;
  let ContestComponent = null;

  switch (type) {
    case "CONTEST_BANNER":
      ContestComponent = ContestCard;
      needProps = true;
      break;
    case "YOUR_TASK":
      ContestComponent =
        !isPastContest &&
        !contest_start_date &&
        !contest_ended &&
        !can_only_view
          ? YourTaskCard
          : null;
      needProps = true;
      break;
    case "CONTEST_UPDATE":
      ContestComponent = !can_only_view ? ContestUpdate : null;
      needProps = true;
      break;
    case "MY_PERFORMANCE":
      ContestComponent = !can_only_view ? MyPerformance : null;
      needProps = true;
      break;
    case "ELIGIBILITY_BANNER":
      ContestComponent = can_only_view ? EligibilityBanner : null;
      needProps = true;
      break;
    case "TIPS_BANNER":
      ContestComponent =
        !isPastContest && !contest_ended && !can_only_view ? TipsBanner : null;
      needProps = true;
      break;
    case "CONTEST_RULES":
      ContestComponent = !isPastContest && !contest_ended ? ContestRules : null;
      needProps = true;
      break;
    case "YOUR_JOURNEY":
      ContestComponent =
        !contest_start_date && !can_only_view ? JourneyProgress : null;
      needProps = true;
      break;
    case "ORDERS_PLACED_CARD":
      ContestComponent = !can_only_view ? OrdersPlacedCard : null;
      needProps = true;
      break;
    default:
      return null;
  }

  const entityProps = needProps ? props : {};
  return ContestComponent ? <ContestComponent {...entityProps} /> : null;
};

export default RenderContestEntity;
